import { ChangeEvent, useState } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";
import { TextareaFormGroup } from "../../common/textarea-form-group/textarea-form-group";
import { resources } from "@constants/hardcoded-strings";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type RejectIdentityProviderChangeRequestModalProps = {
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void, data: string) => Promise<IdentityProviderChangeRequestResponse>;
};

export const RejectIdentityProviderChangeRequestModal = (props: RejectIdentityProviderChangeRequestModalProps) => {
    const { onModalClose, onSubmitHandler } = props;
    const [comments, setComments] = useState("");

    const handleCommentsChange = (event: ChangeEvent<HTMLInputElement>) => {
        setComments(event.target.value);
    };

    const bodyElement = (
        <div>
            <p>{resources.modals.rejectIdentityProviderChangeRequest.description}</p>
            <TextareaFormGroup
                controlId="reject-change-request-comments"
                disabled={false}
                isRequired={false}
                label={resources.modals.rejectIdentityProviderChangeRequest.inputs.rejectionComments.label}
                onChange={handleCommentsChange}
                value={comments}
            />
        </div>
    );

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose, comments);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.REJECT}
            title={resources.modals.rejectIdentityProviderChangeRequest.title}
            body={bodyElement}
            buttonText={resources.modals.rejectIdentityProviderChangeRequest.buttonText}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};